import { RouteRecordRaw } from 'vue-router'

const Contacts = () =>
  import(/* webpackChunkName: "contacts-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'contactos',
    name: 'contacts',
    component: Contacts,
    meta: {
      title: 'Contactos',
      auth: {
        requiredPermission: 'contacts.view',
        requiredModule: 'contacts',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
